<template>
  <div class="radio-containner">
    <table>
      <tbody>
        <tr>
          <td>
            <input
              :name="eventName"
              type="radio"
              :style="radioStyle"
              @click.stop="handleClick"
              :checked="checked"
            />
          </td>
          <td>
            <div class="radio-label" :style="labelStyle" @click.stop="handleClick">
              <slot></slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "Radio",
  data() {
    return {};
  },
  props: {
    size: {
      type: Number,
      default: 35
    },
    fontSize: {
      type: Number,
      default: 30
    },
    eventName: {
      type: String
    },
    index: {
      type: Number,
      default: 0
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {},
    handleClick() {
      this.$emit(this.eventName, this.index);
    }
  },
  computed: {
    radioStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        margin: "0px",
        marginTop: "5px"
      };
    },
    labelStyle() {
      return {
        fontSize: `${this.fontSize}px`
      };
    }
  }
};
</script>
<style lang="less" scoped>
.radio-containner {
  background: transparent;
  display: inline-block;
}
.radio-td {
  background: transparent;
  vertical-align: center;
  padding-left: 5px;
}
.radio-label {
  margin-left: 8px;
  min-width: 100px;
}
table,
tbody,
tr {
  background-color: transparent;
}
table {
  input {
    width: 50px !important;
    height: 50px !important;
  }
  .radio-label {
    font-size: 45px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/Radio.vue